module.exports = __webpack_public_path__ + "static/img/testimony (71).1fb21ed4.jpg";